import React, { Component } from 'react';
import { Button, Card, CardActions, CardTitle, Cell, Grid, TextField , SelectField } from 'react-md';
import { AppProperties } from '../common/functions';
import { NotificationManager } from 'react-notifications';
import "../css/profile.css"

class Profile extends Component {
    constructor(props) {
        super(props);

        this.state = {
            firstName: '',
            lastName: '',
            emailID: '',
            password1: '',
            password2: '',
            selectedPronoun:'',
            pronoun:null,
            passwordRegexError: false,
            passwordRegexErrorText:'Please enter the password',
            passwordConfirmError:false,
            passwordConfirmErrorText:'Please enter the password again'

        };
        this.passwordRef = React.createRef(null);
        this.passwordConfirmRef = React.createRef(null);
    }

    componentDidMount() {
        this.getUserDetails();
    }
    pronounIds = {
        "he/him": 1,
        "she/her": 2
    };
   
    getUserDetails = () => {
        const response = this.props.apiService({
            method: 'get',
            url: '/getUserDetailsByUserName'
        });

        response.then(res => {
            console.debug("res.data.status", res.data.status);
            if (res && res.data.status === 0) {
                const userData = res.data.data;
                const invertedPronounMap = {};
                for (const [name, value] of Object.entries(this.pronounIds)) {
                  invertedPronounMap[value] = name;
                }
                this.setState({
                    firstName: userData?.firstName,
                    lastName: userData?.lastName,
                    emailID: userData?.emailid,
                    pronounIds: userData?.pronoun,
                    selectedPronoun: invertedPronounMap[userData?.pronoun],
                });
            } else {
                NotificationManager.error(res.data?.message, "ERROR", 3000);
            }
        });
    }
   
    checkIfUpdatePayloadIsValid = (payload) => {

        if (payload.firstName === "" || payload.lastName === "") {
            NotificationManager.warning("Please enter first name and last name", "Empty Fields", 5000);
            return false
        }; 
         const validatePassword = (password) => {
           if (
             password.match(/[a-z]/g) &&
             password.match(/[A-Z]/g) &&
             password.match(/[0-9]/g) &&
             password.match(/[^a-zA-Z\d]/g) &&
             password.length >= 8
           )
             return true;
           else return false;
         };
         if (!validatePassword(this.passwordRef.current.value)) {
             this.setState({
                passwordRegexError:true,
                passwordRegexErrorText:`Password should contain
                atleast 1 uppercase character,
                atleast 1 lowercase character,
                atleast 1 digit,
                atleast 1 special character and
                should be minimum 8 characters`
             })
           this.passwordRef.current.focus();
           return false;
         }
         if (this.passwordConfirmRef.current.value.length <= 0) {
           this.passwordConfirmRef.current.focus();
           return false;
         } else {
           if (this.passwordConfirmRef.current.value !== this.passwordRef.current.value) {
             this.setState({
                passwordConfirmErrorText:"Both Passwords must match",
                passwordConfirmError:true
             })
             this.passwordConfirmRef.current.focus();
             return false;
           }
         }

        return true;
    }

    updateProfile = () => {
        this.setState({
            passwordConfirmError:false,
            passwordRegexError:false
        })
        let payload = {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            pronoun  : this.state.pronoun,  
            emailID: this.state.emailID,
            password: this.state.password2
        }

        if (!this.checkIfUpdatePayloadIsValid(payload)) return;

        const response = this.props.apiService({
            method: 'post',
            url: '/updateProfile',
            data: payload
        });

        response.then(res => {
            this.setState({
                password1:"",
                password2:""
            })
            if (res && res.data.status === 0) {
                NotificationManager.success("Successfully updated your profile", "SUCCESS", 3000);
            } else {
                NotificationManager.error(res.data?.message, "ERROR", 3000);
            }
        })
    }

    handleFirstNameChange = value => {
        this.setState({ firstName: value });
    }

    handleLastNameChange = value => {
        this.setState({ lastName: value });
    }

    handleEmailIDChange = value => {
        this.setState({ emailID: value });
    }

    handlePassword1Change = value => {
        this.setState({ password1: value });
    }

    handlePassword2Change = value => {
        this.setState({ password2: value });
    }
    handlePronounChange = (value) => {
      this.setState({ selectedPronoun : value})
      // Map selected pronouns to pronoun IDs
      this.setState({ pronoun : this.pronounIds[value]});
    };

    render() {

        return (
            <Grid>
                <Cell size={4}>
                    <Card>
                        <CardTitle>
                            <h3 style={{color:"#bb0000"}}>Profile</h3>
                        </CardTitle>
                       <div className='d-none justify-content-center align-items-center'>
                        <div style={{
                                width:"100px",
                                height:"100px",
                                borderRadius:"50px",
                                background:"#bb0000",
                                border:"4px solid #dadbdc"
                            }} className='d-flex justify-content-center align-items-center shadow-sm'>
                                <h1 className='text-white'>{this.state.firstName.charAt(0) + this.state.lastName.charAt(0)}</h1>
                            </div>
                       </div>
                        <Grid>
                            <Cell size={6}>
                                <TextField
                                    id="first-name"
                                    label="First Name"
                                    value={this.state.firstName}
                                    onChange={this.handleFirstNameChange}
                                />
                            </Cell>
                            <Cell size={6}>
                                <TextField
                                    id="last-name"
                                    label="Last Name"
                                    value={this.state.lastName}
                                    onChange={this.handleLastNameChange}
                                />
                            </Cell>
                            <Cell size={12}>
                                <TextField
                                    id="email-od"
                                    label="EmailID"
                                    value={this.state.emailID}
                                    disabled
                                    onChange={this.handleEmailIDChange}
                                />
                            </Cell>
                           <Cell  size={12} className='md-text--secondary' >
                                <SelectField size={12}
                                style={{ width:'100%'}}
                                id="pronoun-selector"
                                placeholder="Select pronoun"
                                label="pronoun"
                                value={this.state.selectedPronoun}
                                onChange={this.handlePronounChange}
                                menuItems={["he/him", "she/her"]}
                                />
                            </Cell>
                            <Cell size={12}>
                                <TextField
                                    ref={this.passwordRef}
                                    type="password"
                                    id="password1"
                                    label="Password"
                                    value={this.state.password1}
                                    onChange={this.handlePassword1Change}
                                    errorText={this.state.passwordRegexErrorText}
                                    error={this.state.passwordRegexError}
                                />
                            </Cell>
                            <Cell size={12}>
                                <TextField
                                    ref={this.passwordConfirmRef}
                                    type="password"
                                    id="password2"
                                    label="Confirm Password"
                                    value={this.state.password2}
                                    onChange={this.handlePassword2Change}
                                    errorText={this.state.passwordConfirmErrorText}
                                    error={this.state.passwordConfirmError}
                                />
                            </Cell>
                        </Grid>

                        <CardActions>
                            <Button primary raised className='md-cell--center' onClick={this.updateProfile}>
                                Update
                            </Button>
                        </CardActions>
                    </Card>
                </Cell>
            </Grid>
        );
    }
}

export default Profile;
